export default __webpack_public_path__ + "static/media/Pray.a2c99857.svg";